module.exports = __webpack_public_path__ + "img/burrito.79527a7f.png";